import { calcWinsize } from './utils'
import { UAParser } from 'ua-parser-js'

export default class deviceCheck {
  constructor() {
    this.html = document.querySelector('html')
    this.uaParser = UAParser()
    this.config = {
      tabletWidth: 1024,
      mobileWidth: 768,
    }
    this.isDeviceSize = null
    this.isDevice = null
    this.isBrows = null
    this.winsize = calcWinsize()
    this.init()
  }
  init() {
    this.setUA()
  }

  getBrowser() {
    return this.uaParser.browser.name.replace(/\s+/g, '').toLowerCase()
  }

  getBrowserMajor() {
    return this.uaParser.browser.major.replace(/\s+/g, '').toLowerCase()
  }

  getDevice() {
    const type = this.uaParser.device.type
    let type_result = ''
    /*
        if (type == 'mobile') {
            type_result = 'mobile';
        } else if (type == 'tablet') {
            type_result = 'tablet';
        } else {
            type_result = 'pc';
        }*/

    const ua = navigator.userAgent
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
      type_result = 'mobile' //mobile
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      type_result = 'tablet' //tablet
    } else if (ua.indexOf('Safari') > 0 && ua.indexOf('Chrome') == -1 && typeof document.ontouchstart !== 'undefined') {
      type_result = 'tablet' //tablet ios 13以上
    } else {
      type_result = 'pc'
    }
    return type_result
  }

  getModel() {
    return this.uaParser.device.model ? this.uaParser.device.model.replace(/\s+/g, '').toLowerCase() : ''
  }

  getOS() {
    return this.uaParser.os.name.replace(/\s+/g, '').toLowerCase()
  }

  getDeviceSize() {
    this.winsize = calcWinsize()
    if (this.winsize.width < this.config.mobileWidth) {
      this.isDeviceSize = 'mobile'
    } else if (this.winsize.width < this.config.tabletWidth) {
      this.isDeviceSize = 'tablet'
    } else {
      this.isDeviceSize = 'pc'
    }
    return this.isDeviceSize
  }

  setUA() {
    this.html.classList.add(`is-${this.getBrowser()}`)
    this.html.classList.add(`is-${this.getDevice()}`)
    if (this.getModel()) {
      this.html.classList.add(`is-${this.getModel()}`)
    }
    this.html.classList.add(`is-${this.getOS()}`)
  }
}
